export class ErrorCodes {
  //validation errors, mostly 400s
  static VALIDATION = {
    MISSING_FIELD_BODY: {
      ID: 'VALIDATION.MISSING_FIELD_BODY.ID',
      MEETING_ID: 'VALIDATION.MISSING_FIELD_BODY.MEETING_ID',
      USER_ID: 'VALIDATION.MISSING_FIELD_BODY.USER_ID',
      USER_IDS: 'VALIDATION.MISSING_FIELD_BODY.USER_IDS',
      GROUP_IDS: 'VALIDATION.MISSING_FIELD_BODY.GROUP_IDS',
      STATUS: 'VALIDATION.MISSING_FIELD_BODY.STATUS',
      PASSWORD: 'VALIDATION.MISSING_FIELD_BODY.PASSWORD',
      EMAIL: 'VALIDATION.MISSING_FIELD_BODY.EMAIL',
      FILE: 'VALIDATION.MISSING_FIELD_BODY.FILE',
      CHAT_ID: 'VALIDATION.MISSING_FIELD_BODY.CHAT_ID',
      SOCKET_ID: 'VALIDATION.MISSING_FIELD_BODY.SOCKET_ID',
      PARENT_DIR_ID: 'VALIDATION.MISSING_FIELD_BODY.PARENT_DIR_ID',
      DIRECTORY_ID: 'VALIDATION.MISSING_FIELD_BODY.DIRECTORY_ID',
      SUBSCRIPTION: 'VALIDATION.MISSING_FIELD_BODY.SUBSCRIPTION',
      NAME: 'VALIDATION.MISSING_FIELD_BODY.NAME',
      CONTENT: 'VALIDATION.MISSING_FIELD_BODY.CONTENT',
    },
    MISSING_FIELD_QUERY: {
      ID: 'VALIDATION.MISSING_FIELD_QUERY.ID',
    },
    IS_ARRAY: {
      USER_IDS: 'VALIDATION.IS_ARRAY.USER_IDS',
      GROUP_IDS: 'VALIDATION.IS_ARRAY.GROUP_IDS',
      CONTENT: 'VALIDATION.IS_ARRAY.CONTENT',
      MEMBER_CHANGES: 'VALIDATION.IS_ARRAY.MEMBER_CHANGES',
      ANSWERS: 'VALIDATION.IS_ARRAY.ANSWERS',
    },
    ARRAY_LEN: {
      USER_IDS: 'VALIDATION.ARRAY_LEN.USER_IDS',
    },
    FILE_TYPE: 'VALIDATION.FILE_TYPE',
    INVALID_VALUE: {
      RECIVER_ID_OWN: 'VALIDATION.INVALID_VALUE.RECIVER_ID',
      RECIVER_ID_NOT_FOUND: 'VALIDATION.INVALID_VALUE.RECIVER_ID_NOT_FOUND',
      FILE_NAME_START_END_ILLEGAL: 'VALIDATION.INVALID_VALUE.FILE_NAME_START_END_ILLEGAL',
      PARENT_DIR_NOT_FOUND: 'VALIDATION.INVALID_VALUE.PARENT_DIR_NOT_FOUND',
      PARENT_DIR_CIRCULAR: 'VALIDATION.INVALID_VALUE.PARENT_DIR_CIRCULAR',
      ADD_REMOVE_CONFLICT: 'VALIDATION.INVALID_VALUE.ADD_REMOVE_CONFLICT',
      OVERDUE_AND_CURRENT_CONFLICT: 'VALIDATION.INVALID_VALUE.OVERDUE_AND_CURRENT_CONFLICT',
      INVALID_PAGINATION_DATE: 'VALIDATION.INVALID_VALUE.INVALID_PAGINATION_DATE',
      ADD_REMOVE_NO_ACTION: 'VALIDATION.INVALID_VALUE.ADD_REMOVE_NO_ACTION',
      DIR_ID_NOT_FOUND: 'VALIDATION.INVALID_VALUE.DIR_ID_NOT_FOUND',
      SORT_ORDER: 'VALIDATION.INVALID_VALUE.SORT_ORDER',
      AVATAR: 'VALIDATION.INVALID_VALUE.AVATAR',
      USER_IDS_ARRAY_OR_UNDEFINED: 'VALIDATION.INVALID_VALUE.USER_IDS_ARRAY_OR_UNDEFINED',
      GROUP_IDS_ARRAY_OR_UNDEFINED: 'VALIDATION.INVALID_VALUE.GROUP_IDS_ARRAY_OR_UNDEFINED',
      TAG_ASSIGNMENT_FLAGS: 'VALIDATION.INVALID_VALUE.TAG_ASSIGNMENT_FLAGS',
      FILE_ID_NOT_FOUND: 'VALIDATION.INVALID_VALUE.FILE_ID_NOT_FOUND',
      START_STOP_RANGE: 'VALIDATION.INVALID_VALUE.START_STOP_RANGE',
      START_STOP_CONFLICT: 'VALIDATION.INVALID_VALUE.START_STOP_CONFLICT',
      START_STOP_GTE_0: 'VALIDATION.INVALID_VALUE.START_STOP_GTE_0',
      CONTENT_SCHEMA: 'VALIDATION.INVALID_VALUE.CONTENT_SCHEMA',
      FILE_FILE_ID: 'VALIDATION.INVALID_VALUE.FILE_FILE_ID',
      NO_FILE_FILE_ID: 'VALIDATION.INVALID_VALUE.NO_FILE_FILE_ID',
      ASSIGNMENT_IS_QUIZ: 'VALIDATION.INVALID_VALUE.ASSIGNMENT_IS_QUIZ',
      DUPLICATE_SUBMISSION: 'VALIDATION.INVALID_VALUE.DUPLICATE_SUBMISSION',
      ASSIGNMENT_FEEDBACK: 'VALIDATION.INVALID_VALUE.ASSIGNMENT_FEEDBACK',
      ASSIGNMENT_FEEDBACK_FILE: 'VALIDATION.INVALID_VALUE.ASSIGNMENT_FEEDBACK_FILE',
      DATE_RANGE: 'VALIDATION.INVALID_VALUE.DATE_RANGE',
      ATTENDANCE_STATUS: 'VALIDATION.INVALID_VALUE.ATTENDANCE_STATUS',
    },
  };

  //access forbidden, mostly 403s
  static FORBIDDEN = {
    CHAT: {
      MIXED: 'FORBIDDEN.CHAT.MIXED',
      USER_NOT_ALLOWED: 'FORBIDDEN.CHAT.USER_NOT_ALLOWED',
      NOT_MEMBER: 'FORBIDDEN.CHAT.NOT_MEMBER',
    },
    FS: {
      PERMISSION: {
        NO_WRITE: 'FORBIDDEN.FS.PERMISSION.NO_WRITE',
        NO_READ: 'FORBIDDEN.FS.PERMISSION.NO_READ',
        NO_EDIT: 'FORBIDDEN.FS.PERMISSION.NO_EDIT',
        NO_MANIP_INTERNAL: 'FORBIDDEN.FS.PERMISSION.NO_MANIP_INTERNAL',
      },
    },
    QUIZ: {
      NOT_COMPLETED: 'FORBIDDEN.QUIZ.NOT_COMPLETED',
      NO_VALID_ATTEMPT: 'FORBIDDEN.QUIZ.NO_VALID_ATTEMPT',
      START_ONLY_USER: 'FORBIDDEN.QUIZ.START_ONLY_USER',
      OUTSIDE_AVAILBILITY: 'FORBIDDEN.QUIZ.OUTSIDE_AVAILBILITY',
      EXCEEDED_MAX_ATTEMPTS: 'FORBIDDEN.QUIZ.EXCEEDED_MAX_ATTEMPTS',
      ALREADY_COMPLETED: 'FORBIDDEN.QUIZ.ALREADY_COMPLETED',
      NO_INSTANT_MARK: 'FORBIDDEN.QUIZ.NO_INSTANT_MARK',
      SECTION_MARKED: 'FORBIDDEN.QUIZ.SECTION_MARKED',
      ATTEMPT_ONGOING: 'FORBIDDEN.QUIZ.ATTEMPT_ONGOING',
      ATTEMPT_ONGOING_OTHER_QUIZ: 'FORBIDDEN.QUIZ.ATTEMPT_ONGOING_OTHER_QUIZ',
      ANSWER_INVALIDATION: 'FORBIDDEN.QUIZ.ANSWER_INVALIDATION',
    },
    GRADE: 'FORBIDDEN.GRADE',
    GROUP: 'FORBIDDEN.GROUP',
    ASSIGNMENT: {
      NOT_ASSIGNED: 'FORBIDDEN.ASSIGNMENT.NOT_ASSIGNED',
      NOT_OWNER: 'FORBIDDEN.ASSIGNMENT.NOT_OWNER',
      OUTSIDE_AVAILBILITY: 'FORBIDDEN.ASSIGNMENT.OUTSIDE_AVAILBILITY',
      EXCEEDED_MAX_ATTEMPTS: 'FORBIDDEN.ASSIGNMENT.EXCEEDED_MAX_ATTEMPTS',
    },
    REPORT: {
      NOT_STUDENT: 'FORBIDDEN.REPORT.NOT_STUDENT',
    },
    USER: {
      LVL_UPGRADE: 'FORBIDDEN.USER.LVL_UPGRADE',
      CREATE_LVL: 'FORBIDDEN.USER.CREATE_LVL',
    },
  };

  static NOT_FOUND = {
    ASSIGNMENT: 'NOT_FOUND.ASSIGNMENT',
    ASSIGNMENT_RESPONSE: 'NOT_FOUND.ASSIGNMENT_RESPONSE',
    AVATAR: 'NOT_FOUND.AVATAR',
    CHAT: 'NOT_FOUND.CHAT',
    DIRECTORY: 'NOT_FOUND.DIRECTORY',
    USER: 'NOT_FOUND.USER',
    GRADE: 'NOT_FOUND.GRADE',
    GROUP: 'NOT_FOUND.GROUP',
    FILE: {
      S3_NO_DATA: 'NOT_FOUND.FILE.S3_NO_DATA',
      NO_DB_ENTRY: 'NOT_FOUND.FILE.NO_DB_ENTRY',
    },
    LOCATION: 'NOT_FOUND.LOCATION',
    MEETING: 'NOT_FOUND.MEETING',
    POST: 'NOT_FOUND.POST',
    SUBSCRIPTION: 'NOT_FOUND.SUBSCRIPTION',
    QUIZ: 'NOT_FOUND.QUIZ',
    QUIZ_ATTEMPT: 'NOT_FOUND.QUIZ_ATTEMPT',
    TAG: 'NOT_FOUND.TAG',
  };

  //auth codes, mostly 401s and 403s related to auth endpoints and middlewares
  static AUTH = {
    WRONG_CREDENTIALS: 'AUTH.WRONG_CREDENTIALS',
    ACCOUNT_DEACTIVATED: 'AUTH.ACCOUNT_DEACTIVATED',
    NO_CRED_AND_NO_TOKEN: 'AUTH.NO_CRED_AND_NO_TOKEN',
    TOKEN_NOT_VALID: 'AUTH.TOKEN_NOT_VALID',
    ALREADY_SIGNED_UP: 'AUTH.ALREADY_SIGNED_UP',
    NO_CRED: 'AUTH.NO_CRED',
    TEACHER_AUTH: 'AUTH.TEACHER_AUTH',
    ADMIN_AUTH: 'AUTH.ADMIN_AUTH',
  };

  //db errors including constraints, network etc
  static DB = {
    FOREIGN_KEY_CONSTRAINT: 'DB.FOREIGN_KEY_CONSTRAINT',
    VALIDATION: 'DB.VALIDATION',
    DB_ERR: 'DB.DB_ERR',
    CONN: 'DB.CONN',
    S3_DOWNLOAD: 'DB.S3_DOWNLOAD',
  };

  static EMAIL = {
    SEND_FAILED: 'EMAIL.SEND_FAILED',
  };

  static GENERIC = {
    INTERNAL_SERVER_ERROR_500: 'GENERIC.INTERNAL_SERVER_ERROR_500',
  };
}
